export const degreeMixin = {
  methods: {
    getDegreeName(degreeCode) {
      let name;
      switch (degreeCode) {
        case 1:
          name = 'University degree';
          break;
        case 2:
          name = "Bachelor's degree";
          break;
        case 3:
          name = "Master's degree";
          break;
        case 4:
          name = 'PhD degree';
          break;

        default:
          name = '';
          break;
      }

      return name;
    },
  },
};
